import PropTypes from 'prop-types'
import styled from 'styled-components'
import zIndex from 'theme/zIndex'
import { get } from 'lodash'

const SIZES = {
  sm: '25',
  md: '50',
}

const StyledSpinner = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: ${props => props.position};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: ${props => SIZES[props.size]}px;
  height: ${props => SIZES[props.size]}px;
  z-index: ${props => props.theme.zIndex[props.zIndex]};

  ${props =>
    props.position === 'fixed'
      ? `
    z-index: ${props.theme.zIndex.max};
  `
      : ''}

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    width: ${props => SIZES[props.size]}px;
    height: ${props => SIZES[props.size]}px;
    border: 4px solid ${props => get(props.theme.palette, props.color)};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${props => get(props.theme.palette, props.color)} transparent
      transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const Spinner = props => (
  <StyledSpinner {...props}>
    <div />
    <div />
    <div />
    <div />
  </StyledSpinner>
)

Spinner.propTypes = {
  position: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  zIndex: PropTypes.oneOf(Object.keys(zIndex)),
  color: PropTypes.string,
}

Spinner.defaultProps = {
  position: 'static',
  size: 'md',
  zIndex: 'primary',
  color: 'primary.main',
}

export default Spinner
